export class EmploymentAssetDto {
  constructor(
    public readonly id: number,
    public readonly assetId: number,
    public readonly description: string,
    public readonly beneficiaryEmploymentId?: number,
  ) {}

  public static fromJson(json: any): EmploymentAssetDto {
    if (json) {
      return new EmploymentAssetDto(json.id, json.assetId, json.description, json.beneficiaryEmploymentId);
    }
  }
}
